function initDigitalBrochureNavigation() {
  if (typeof jQuery === "undefined") {
    return;
  }

  const $ = jQuery;

  $(".nav-arrow, .nav-title").on("click", function () {
    $(".wp-block-group").removeClass("active rotate");
    $(this).closest(".wp-block-group").addClass("active rotate");
  });

  $(".brochure-start").on("click", function (event) {
    event.preventDefault();

    $(".side-nav-bar .wp-block-group").removeClass("active rotate");
    $(".side-nav-bar .wp-block-group:eq(0)").addClass("active rotate");

    const href = $($(this).find(".wp-block-boldblocks-svg-block__inner")).attr(
      "href"
    );

    if (href && href.startsWith("#") && $(href).length) {
      $("html, body").animate(
        {
          scrollTop: $(href).offset().top,
        },
        500
      );
    }
  });

  const sections = $(".wp-block-group")
    .map(function () {
      const href = $(this).find("a").first().attr("href");
      if (href && href.startsWith("#") && $(href).length) {
        return $(href);
      }
      return null;
    })
    .get();

  $(window).on("scroll", function () {
    $(".wp-block-group").removeClass("active rotate");

    for (let i = 0; i < sections.length; i++) {
      if (sections[i] !== undefined) {
        const sectionTop = sections[i].offset().top;
        const sectionBottom = sectionTop + sections[i].height();
        const windowTop = $(window).scrollTop();

        if (windowTop >= sectionTop && windowTop <= sectionBottom) {
          $(`.wp-block-group:eq(${i})`).addClass("active rotate");
          break;
        }
      }
    }
  });

  $('a[href^="#"]').on("click", function (event) {
    event.preventDefault();

    const target = this.hash;
    const $target = $(target);

    if ($target.length) {
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top,
          },
          900,
          "swing",
          function () {
            window.location.hash = target;
          }
        );
    }
  });
}

export default initDigitalBrochureNavigation;
